<template lang="pug">
modal#onboarding-fields-modal(
  :cancelAction='backAction'
  :closeButtonLabel='$t("button.back")'
  :process-button-label='processButtonLabel'
  :show-cancel-button='showCancelButton'
  :title='$t("modal.onboarding_fields.title")'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12
    template(v-if='step === 1')
      p {{ $t('modal.onboarding_fields.step1_text') }}
      .text-center
        img.img-fluid(
          src='/img/ilustrations/onboarding-envelope-fields-select-document.gif'
        )
    template(v-if='step === 2')
      p {{ $t('modal.onboarding_fields.step2_text') }}
      .text-center
        img.img-fluid(
          src='/img/ilustrations/onboarding-envelope-fields-add-fields.gif'
        )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      step: 1,
      finalStep: 2,
    };
  },
  computed: {
    processButtonLabel() {
      return this.step === this.finalStep
        ? this.$t('button.ok')
        : this.$t('button.next');
    },
    showCancelButton() {
      return this.step > 1;
    },
  },
  methods: {
    process() {
      if (this.step === this.finalStep) {
        this.$refs.modal.close();
        this.$emit('finished');
        return;
      }
      this.step += 1;
    },
    backAction() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
  },
};
</script>
